'use strict';

var helper = require('../helper');

module.exports = {

    // Cart Interactions
    pushCheckoutButtonsFromCartInteraction (name, location) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '2',
            'eventname': 'checkout_express_start',
            'position': location || 'from_cart',
            'type': name
        };

        helper.log('Pushing click impression:', true);
        helper.push(pushObject);
    },

    pushCartAppliedCouponCode (code, btnAction, where) {
        let action = btnAction !== undefined ? btnAction : 'apply';
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '31',
            'eventname': 'coupon',
            'action': action,
            'coupon': code,
            'area': where
        };

        helper.log('Pushing coupon code applied impression: \'' + code + '\'', true);
        helper.push(pushObject);
    },

    // 7.117 SHIPPING METHODS - LINK IN THE SHOPPING BAG
    pushShippingMethodsMoreInfo (cta) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '124',
            'eventname': 'shipping_info',
            'category': 'shipping_methods',
            'action': cta,
            'position': 'from_cart'
        };

        helper.log('Pushing shipping methods more info click', true);
        helper.push(pushObject);
    },

    // Minicart
    pushMinicartCheckoutClickInteraction () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '1',
            'eventname': 'minicart_cart',
            'type': 'go_to_shopping_bag'
        };

        helper.log('Pushing click impression:', true);
        helper.push(pushObject);
    },

    pushExpressCheckoutClickInteraction (name) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '1',
            'eventCategory': 'way_to_checkout',
            'eventAction': name,
            'eventLabel': 'from_cart_preview',
            'dimension72': 'from_cart_preview',
            'dimension73': name
        };

        helper.log('Pushing click impression:', true);
        helper.push(pushObject);
    },

    pushFastShippingMethodClickInteraction (type, user, name) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '78',
            'eventname': 'checkout_express_shipping',
            'step': 'shipping_method',
            'shipping_method': type,
            'type': user || 'not_available',
            'store': name
        };

        helper.log('Pushing fast checkout shipping choice actions: ', true);
        helper.push(pushObject);
    },

    pushFastPaymentClickInteraction (method, user) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '79',
            'eventname': 'checkout_express_terms_and_conditions',
            'step': 'terms_and_conditions_of_sale',
            'payment_method': method,
            'type': user || 'not_available'
        };

        helper.log('Pushing fast checkout payment actions: ', true);
        helper.push(pushObject);
    },

    pushChangeShippingFastInteraction (method, user) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '80',
            'eventname': 'shipping_address',
            'action': 'change',
            'shpping_method': method,
            'position': 'fast_checkout',
            'type': user || 'not_available'
        };

        helper.log('Pushing change shipping fast checkout: ', true);
        helper.push(pushObject);
    },

    // 6.91 HANDLE GIFT CARD MAN-WOMAN
    pushHandleGiftCard (eventId, ctaName) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': eventId,
            'eventID': '94',
            'eventname': 'gift_card',
            'action': ctaName
        };

        helper.log('Pushing buy gift card by gender: ', true);
        helper.push(pushObject);
    },

    // 6.128 ADD AND SAVE THE PRODUCTS INSIDE THE GIFTWRAP
    pushProductsInsideGiftWrap (productsname, skus) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '127',
            'eventname': 'gift_wrap',
            'action': 'insert_the_product_inside_to_the_gift_wrap',
            'product_id': skus
        };

        helper.log('Pushing products in gift wrap: ', true);
        helper.push(pushObject);
    },
    // 6.129 ADD THE GIFT PAPER (KIT)
    pushGiftKit (quantity) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '128',
            'eventname': 'self_gift',
            'action': 'add',
            'label': quantity
        };

        helper.log('Pushing buy gift paper: ', true);
        helper.push(pushObject);
    },
    pushShippingMoreInfo (topic) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '129',
            'eventname': 'shipping_info',
            'action': 'more_info',
            'category': topic
        };

        helper.log('Pushing more shipping info: ', true);
        helper.push(pushObject);
    },
    pushPaymentMoreInfo (topic) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '131',
            'eventname': 'payment_info',
            'action': 'info_on_card_saving'
        };

        helper.log('Pushing more payment info: ', true);
        helper.push(pushObject);
    },
    pushOrderReviewProceed () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '132',
            'eventname': 'order_review_proceed'
        };

        helper.log('Pushing order review proceed: ', true);
        helper.push(pushObject);
    },
    pushOrderReview (action, where) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '133',
            'eventname': 'review_order',
            'action': action,
            'position': where
        };

        helper.log('Pushing order review: ', true);
        helper.push(pushObject);
    },
    pushMinicartInteraction (cta) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '144',
            'eventname': 'minicart_cart',
            'type': cta
        };

        helper.log('Pushing minicart interaction', true);
        helper.push(pushObject);
    },
    pushBeginCheckout (data) {
        let pushObject = {
            'event': 'begin_checkout',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'upselling_message': data.upselling_message,
            'ecommerce': {
                'currency': data.currency,
                'value': parseFloat(data.value),
                'coupon': data.coupon,
                'items': data.items
            }
        };

        helper.log('Pushing begin checkout', true);
        helper.push({ecommerce: null});
        helper.push(pushObject);
    }
};
